<template>
	<div class="row mb-4">
		<TheHeader />
	</div>
		
	<div class="row">
		<div class="col-sm-2">
    		<TheSidebar />
		</div>
		<div class="col-sm-10">
			<router-view />
		</div>
	</div>
    <TheFooter />
</template>

<script>
import TheHeader from '@/partials/TheHeader.vue'
import TheFooter from '@/partials/TheFooter.vue'
import TheSidebar from '@/partials/TheSidebar.vue'

export default {
  name: 'SidebarLayout',
  components: {
      TheHeader,TheFooter,TheSidebar
  }
}
</script>
